import { getOperationName } from 'apollo-utilities';
import { gql, useMutation } from '@apollo/client';
import {
  ORDER_HISTORY_QUERY,
  SEARCH_ORDER_HISTORY_QUERY,
} from '@/hooks/use-order-history-list-query';
import { ORDER_ITEM_RATING_FRAGMENT } from '@/components/order-item-list';
import { ORDER_STATUS_LABEL_FIELDS } from '@/components/orders/order-status-label';
import {
  OrderItemRatingInput,
  Orders_RateOrderMutation,
  Orders_RateOrderMutationVariables,
} from '@/types';
import { ReviewState } from './use-review-form-reducer';

export const RATE_ORDER_MUTATION = gql`
  mutation Orders_RateOrder($ratings: [OrderItemRatingInput!]!) {
    rateOrder(order_item_ratings: $ratings) {
      order {
        ...OrderStatusLabelFields
        orders_items {
          order_item_rating {
            ...OrderItemRatingFields
          }
          uuid
        }
        uuid
      }
    }
  }
  ${ORDER_STATUS_LABEL_FIELDS}
  ${ORDER_ITEM_RATING_FRAGMENT}
`;

const createOrderRatings = (
  reviewState: ReviewState,
): OrderItemRatingInput[] => {
  return Object.keys(reviewState.reviews).map((orderItemUUID) => {
    const review = reviewState.reviews[orderItemUUID];

    return {
      comment: review.comment,
      order_item_id: orderItemUUID,
      photo_url_list: review.photoUrlList,
      rating: review.rating,
    };
  });
};

export const useRateOrder = () => {
  const [submitRateOrder, { loading, error }] = useMutation<
    Orders_RateOrderMutation,
    Orders_RateOrderMutationVariables
  >(RATE_ORDER_MUTATION, {
    refetchQueries: [
      getOperationName(ORDER_HISTORY_QUERY) as string,
      getOperationName(SEARCH_ORDER_HISTORY_QUERY) as string,
    ],
  });

  return {
    error,
    loading,
    rateOrder: async (reviewState: ReviewState) => {
      await submitRateOrder({
        variables: {
          ratings: createOrderRatings(reviewState),
        },
      });
    },
  };
};
